import React, {useCallback, useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import RadioButtonChecked from '@material-ui/icons/Check'
import StepConnector from '@material-ui/core/StepConnector';
import {makeStyles, Paper, StepLabel, Typography} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import RenderComponents from "./RenderComponents";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Utils/lib";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {uid} from "react-uid";
import {withStyles} from "@material-ui/core/styles";
import useWebSocket from "../../../../Hooks/useWebSocket";
import {generateBorder} from "../../Utils/generateStyles";
import clsx from "clsx";
function scrollToTop() {
    //scroll to top active step
    const parentContainer = document.getElementById(`sb-stepper-content-parent`)
    parentContainer.scrollTo(0,0)
}
const Connector = withStyles({
    line: {
        borderColor: '#F5F6F8',
        borderTopWidth: 1,
        borderRadius: 1,
    },
})(StepConnector);
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    stepperRoot: {
        padding: '4px 0 12px 0'
    },
    stepButtonRoot: {
        padding: '4px 16px',
        //background: '#E0EEFD',
        //borderRadius: '26px'
    },
    completedStep: {
        //backgroundColor: 'lightcyan',
        // color: 'lightgreen'
    },
    nextButton: {
        margin: '0 8px',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    rootStep: {
        width: 120
    }
}));
const additionalAreaSource = {children: []}
const StepperComponent = (props) => {
    const {
        element: {
            properties: {
                hideDeleteBtn,
                hideBackBtn,
                hideCancelBtn,
                linear,
                restrictTopNav,
                submitLabel,
                nextLabel,
                backLabel,
                cancelLabel,
                deleteLabel,
                title
            },
            events,
            children,
            styles: sourceStyles
        },
        loadingData,
        containerArrayPath, basePath, doActions, goBack, globalValues, screenName
    } = props;
    const screenInfo = useSelector(state => state.jsonScreen.screenInfo[screenName])
    const {userLanguage} = useSelector(state => state.app);
    const [activeStep, setActiveStep] = useState(0);
    const [isCompletedStep, setIsCompletedStep] = useState(false);
    const [stepperEvents, setStepperEvents] = useState({});
    const [steps, setSteps] = useState([])
    const [completedSteps, setCompletedSteps] = useState({});
    const [additionalArea, setAdditionalArea] = useState(additionalAreaSource)
    const styles = sourceStyles ? sourceStyles[0] : {};
    const actionButtonStyles = sourceStyles ? sourceStyles[2] : {};
    const classes = useStyles();
    const isHiddenDelete = checkHidden(globalValues, hideDeleteBtn, screenName);
    const isHiddenBack = checkHidden(globalValues, hideBackBtn, screenName);
    const isHiddenCancel = checkHidden(globalValues, hideCancelBtn, screenName)
    const isRestrictedTopNav = checkHidden(globalValues, restrictTopNav, screenName);
    const isCompletedStepCondition = steps[activeStep] ? steps[activeStep].properties.isCompleted : false;
    const isCompleted = getParamsFromString(isCompletedStepCondition, globalValues, screenName);
    const nextButtonType = steps[activeStep] ? steps[activeStep].properties ? steps[activeStep].properties.validateFields ? 'submit' : 'button' : 'button' : 'button';
    let borderObj = generateBorder(styles);
    const multiLanguageTitle = multiLanguageValue(title, userLanguage);
    useEffect(() => {
        let strToBool = isCompleted === ('true' || true);
        let isCompletedExec = isCompletedStepCondition && isCompletedStepCondition.length > 0 ? strToBool : true;
        setIsCompletedStep(isCompletedExec)
        setCompletedSteps((prev) => {
            return {
                ...prev,
                [activeStep]: isCompletedExec
            }
        })
    }, [activeStep, isCompleted, isCompletedStepCondition])
    useEffect(() => {
        let evts = {stepper: {}};
        const steps = children.filter(ch => ch.type === 'step');
        const additionalAreaIndex = children.findIndex(ch => ch.type === 'stepperAdditionalArea');
        setSteps(steps.map(i => {
            return {properties: {}, ...i}
        }));
        setAdditionalArea(additionalAreaIndex === -1 ? additionalAreaSource : children[additionalAreaIndex]);
        //events for stepper
        if (events && events.length) {
            for (let event of events) {
                if (event.event) {
                    evts.stepper[event.event] = event.actions;
                }
            }
        }

        //events for every step with index key
        for (let [i, {events}] of steps.entries()) {
            if (events && events.length) {
                for (let event of events) {
                    if (event.event) {
                        evts[i] = {};
                        evts[i][event.event] = event.actions;
                    }
                }

            }
        }
        setStepperEvents(evts)
        if (screenInfo) {
            try {
                const queryToJson = JSON.parse(screenInfo);
                if (queryToJson.step) {
                    setActiveStep(queryToJson.step)
                }
            } catch (e) {
                console.log(e)
            }
        }
    }, []);

    /**
     *
     * @param step Number
     * @param action one of onClickNext, onClickPrev
     * @param validate Boolean
     * @returns {Promise<void>}
     */
    async function handleStep(step, action, validate) {
        const stepProps = steps[activeStep].properties;

        if (validate && stepProps.validateFields) {
            props.submitFnRef.current = async () => {
                if (stepperEvents[activeStep]) {
                    if (stepperEvents[activeStep][action]) {
                        await doActions(stepperEvents[activeStep][action])
                    }
                }
                setCompletedSteps((prev) => {
                    return {
                        ...prev,
                        [activeStep]: true
                    }
                })
                setActiveStep(step)
                scrollToTop()
            }
            return
        }
        if (stepperEvents[activeStep]) {
            if (stepperEvents[activeStep][action]) {
                await doActions(
                    stepperEvents[activeStep][action], {
                        doc: {
                            goNextStep: function () {
                                setActiveStep()
                            }
                        }
                    })
            }
            scrollToTop()
        }

        if (!isRestrictedTopNav) {
            setActiveStep(step);
            scrollToTop()
        }
    }

    const goNextStep = useCallback(() => {
        setActiveStep(activeStep + 1);
    }, [activeStep])

    async function onFinish() {
        console.log('finish', stepperEvents.stepper)
        if (stepperEvents.stepper && stepperEvents.stepper.onFinish) {
            await doActions(stepperEvents.stepper.onFinish)
        }
    }

    async function onDelete() {
        if (stepperEvents.stepper && stepperEvents.stepper.onDelete) {
            await doActions(stepperEvents.stepper.onDelete)
        }
    }

    return (
        <div style={{
            height: styles.height,
            width: styles.width,
        }}
             className={"sb-stepper-container"}
        >
            <Paper style={{
                height: 'inherit',
                boxShadow: `${styles.boxShadow} ${styles.shadowColor}`,
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                ...borderObj,
                borderRadius: styles.borderRadius,
            }}
                   className={"sb-stepper-paper"}
            >
                <div><Typography>{multiLanguageTitle}</Typography></div>
                <Stepper activeStep={activeStep} nonLinear={!linear}
                         style={{overflow: 'auto', background: styles.background}}
                         connector={<Connector/>}
                >
                    {(steps || []).map((step, index) => {
                        const multiLanguageLabel = multiLanguageValue(step.properties.label, userLanguage);
                        return (
                            <Step key={index}
                                  completed={completedSteps[index]}
                                  classes={{
                                      completed: classes.completedStep
                                  }}
                            >
                                <StepLabel
                                    onClick={() => {
                                        if (isRestrictedTopNav) return;
                                        handleStep(index, activeStep > index ? 'onClickPrev' : 'onClickNext', false)
                                    }}
                                    StepIconComponent={({active, completed}) => {
                                        return <CustomStepButton index={index} active={active} completed={completed}
                                                                 label={multiLanguageLabel}
                                        />
                                    }}
                                >
                                    {multiLanguageLabel}
                                </StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
                <Divider style={{background: '#F5F6F8'}}/>
                <div
                    id={`sb-stepper-content-parent`}
                    style={{margin: 2, height: 'calc(100% - 123px)', overflow: 'auto'}}>
                    {steps.map((step, index) => {
                        const isVisible = activeStep === index;
                        const {properties: {renderWhenVisible}} = step;
                        return (
                            <div
                                key={uid(step)}
                                className={'sb-stepper-content-container'}
                                style={{
                                    display: isVisible ? 'block' : 'none',
                                    height: isVisible ? '100%' : 0,
                                }}>
                                {renderWhenVisible ? (isVisible && (
                                    <StepContent
                                        step={step}
                                        containerArrayPath={containerArrayPath}
                                        basePath={basePath}
                                        isVisibleTab={isVisible}
                                        doActions={doActions}
                                        goNextStep={goNextStep}
                                    />
                                )) : (<StepContent
                                    step={step}
                                    containerArrayPath={containerArrayPath}
                                    basePath={basePath}
                                    isVisibleTab={isVisible}
                                />)}

                            </div>
                        )
                    })}
                </div>
                <Divider style={{background: '#F5F6F8'}}/>
                <div style={{display: 'flex', justifyContent: 'space-between', height: 40}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        {!Boolean(isHiddenCancel) && (
                            <Button
                                size={"small"}
                                color={"default"}
                                variant={"contained"}
                                className={clsx("sb-button-default", classes.nextButton)}
                                onClick={goBack}
                                style={actionButtonStyles}
                                disabled={loadingData}
                            >
                                {multiLanguageValue(cancelLabel, userLanguage) || "Cancel"}
                            </Button>
                        )}
                        {!Boolean(isHiddenDelete) && (
                            <Button
                                size={"small"}
                                color={"secondary"}
                                variant={"outlined"}
                                className={clsx("sb-button-default", classes.nextButton)}
                                onClick={onDelete}
                                disabled={loadingData}
                                style={actionButtonStyles}
                            >
                                {multiLanguageValue(deleteLabel, userLanguage) || "Delete"}
                            </Button>
                        )}
                        <AdditionalArea
                            component={additionalArea}
                        />
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        {!isHiddenBack && activeStep > 0 && (
                            <Button
                                size={"small"}
                                color={"primary"}
                                variant={"outlined"}
                                className={clsx("sb-button-default", classes.nextButton)}
                                disabled={!activeStep || loadingData}
                                style={actionButtonStyles}
                                onClick={() => handleStep(activeStep - 1, 'onClickPrev', false)}
                            >
                                {multiLanguageValue(backLabel || "Back", userLanguage)}
                            </Button>
                        )}
                        <Button
                            size={"small"}
                            color={"primary"}
                            variant={"contained"}
                            disabled={loadingData ? loadingData : linear ? !isCompletedStep : false}
                            className={clsx("sb-button-default", classes.nextButton)}
                            type={nextButtonType}
                            form={screenName + '_screenForm'}
                            style={actionButtonStyles}
                            onClick={() => {
                                activeStep + 1 >= steps.length ? onFinish() : handleStep(activeStep + 1, 'onClickNext', true)
                            }}
                        >
                            {activeStep + 1 >= steps.length ? multiLanguageValue(submitLabel || "Submit", userLanguage) : multiLanguageValue(nextLabel || "Next", userLanguage)}
                        </Button>
                    </div>
                </div>
            </Paper>
        </div>
    )
};

export default JsonScreenHoc(StepperComponent)

StepperComponent.propTypes = {
    element: PropTypes.shape({
        properties: PropTypes.object,
        styles: PropTypes.array,
        events: PropTypes.array,
        children: PropTypes.array
    }),
    containerArrayPath: PropTypes.string
};
StepperComponent.defaultProps = {
    element: {}
};


const StepContent = ({step, containerArrayPath, basePath, isVisibleTab, doActions, goNextStep}) => {
    const {children = [], styles = [], events = []} = step;
    const sourceStyles = styles.length ? styles[0] : {};

    useWebSocket(events, doActions, {goNextStep: goNextStep})

    return (
        <div style={{
            height: sourceStyles.height || 150,
            width: sourceStyles.width || '100%',
            padding: sourceStyles.padding,
            display: 'flex',
            alignItems: 'baseline',
            flexDirection: 'column',
            overflow: 'auto'
        }}>
            {children.map(item => (
                <RenderComponents
                    key={uid(item)}
                    containerArrayPath={containerArrayPath}
                    basePath={basePath}
                    element={item}
                    actionsContext={{isVisibleTab}}
                />
            ))}
        </div>
    )
};

const AdditionalArea = ({component}) => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center'
            }}
        >
            {component.children.map(item => {
                return (
                    <RenderComponents
                        key={uid(item)}
                        element={item}
                    />
                )
            })}
        </div>
    )
}

const CustomStepButton = ({active, completed, index}) => {
    return (
        <div
            style={{
                width: 40,
                height: 40,
                background: completed ? '#E0EEFD' : active ? 'rgba(235,145,37,0.2)' : 'white',
                color: active ? '#EB9125' : '#007DC4',
                border: !active && !completed && '1px solid #007DC4',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            className={clsx(
                {
                    "sb-stepper_stepButton-completed": completed,
                },
                {
                    "sb-stepper_stepButton-active": active
                },
                "sb-stepper_stepButton",
            )}
        >{completed ? <RadioButtonChecked fontSize={"small"}/> : index + 1}</div>
    )
}
